
import React from 'react';
import { User } from "lucide-react";

const FormHeader: React.FC = () => {
  return (
    <div className="flex items-center space-x-2">
      <div className="bg-primary/10 p-2 rounded-full">
        <User className="h-5 w-5 text-primary" />
      </div>
      <h2 className="text-xl md:text-2xl font-semibold">Dane do zamówienia</h2>
    </div>
  );
};

export default FormHeader;
